<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="提取数据"
      id-key="ClassId"
      :data="data"
      :line-form="true"
      form-label-width="100px"
      :form-rules="rules"
      :save-func="() => {}"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <template v-if="is_Status === 0">
          <el-form-item label="存货编码">
            <el-input v-model="data.ProductNo" placeholder="请输入存货编码" />
          </el-form-item>
          <el-form-item label="存货名称">
            <el-input v-model="data.ProductName" placeholder="请输入存货名称" />
          </el-form-item>
        </template>
        <template v-if="is_Status === 1">
          <el-form-item label="供应商编码">
            <el-input
              v-model="data.TradeUnitNo"
              placeholder="请输入供应商编码"
            />
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input
              v-model="data.TradeUnitName"
              placeholder="请输入供应商名称"
            />
          </el-form-item>
        </template>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">查 询</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ProductName: "",
        ProductNo: "",
        TradeUnitNo: "",
        TradeUnitName: "",
      },
      is_Status: 0,
      api: require("@/api/pu/puGoodsPriceTradeUnit").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {},
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
      console.log("data", data);
      this.is_Status = data;
    },

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        this.api.productList(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if (res.Data.length == 0)
              return this.$message.warning("未提取相应数据，请检查是否相应数据已存在或筛选不到相应数据");
            let tableList = res.Data?.reduce((acc, item) => {
              acc.push({
                GoodsPriceTradeUnitId: 0,
                // ProductId: 0,
                // PurchasePrice: 0,
                // TradeUnitId: 0,
                // FinalPrice: 0,
                // PurchaseRatio: 0,
                // UpdateEmpId: 0,
                // UpdateDate: "2022-10-05T07:55:17.657Z",
                // AddUserId: 0,
                // AddTime: "2022-10-05T07:55:17.657Z",
                // Deadline: "2022-10-05T07:55:17.657Z",
                // Remark: "",
                // ClassCustomerId: 0,
                ...item,
                 Deadline: this.$commonJs.getToday(),
                UpdateEmpId: this.$commonJs.empId(),
                UpdateDate: this.$commonJs.getToday(),
                AddUserId: this.$commonJs.userId(),
                AddTime: this.$commonJs.getToday(),
              });
              return acc;
            }, []);
            if (tableList.length > 0) {
              return this.$confirm("提取到"+tableList.length+"条记录，是否确定保存", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                var loading = this.$loading({
                  lock: true,
                  text: "正在保存...",
                  spinner: "el-icon-loading",
                  customClass: "my_loading",
                  background: "rgba(0, 0, 0, 0.3)",
                });
                this.api.save(tableList).then((result) => {
                  if (res.Code === 0) {
                    this.$parent.findList();
                    this.$message.success(result.Msg);
                    // this.$emit("close-saved");
                    this.close(true);
                  } else this.$message.error(result.Msg);
                  loading.close();
                });
              });
            }

           
          } else {
            this.$message.error(res.Msg);
          }
        });
        // this.$parent.onExport(data);
        // this.$parent.findList(data);
        this.$emit("close-saved");
        this.close(true);
        // this.$refs.dialog.isLoading = true;
        // this.api.save(data).then((res) => {
        //   this.$refs.dialog.isLoading = false;
        //   if (res.Code == 0) {
        //     this.$message.success(res.Msg);
        //     this.$emit("close-saved");
        //     this.close(true);
        //   } else {
        //     this.$message.error(res.Msg);
        //   }
        // });
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
